import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EditNonLifeInsuranceForm } from "web_myplann/Portfolio/Pages/NonLifeInsuranceEdit/EditNonLifeInsuranceForm";
import { PortfolioEditLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioEditLayout";

export const EditNonLifeInsurancePage = () => {
	const { t } = useResource();

	return (
		<PortfolioEditLayout
			expectedDomain={ClientPortfolioDomainEnum.PropertyInsurance}
			title={t(Resources.Portfolio.EditPortfolio.title)}
		>
			{({ portfolio, portfolioId, detailRoute }) => (
				<EditNonLifeInsuranceForm
					portfolioId={portfolioId}
					portfolio={portfolio}
					detailRoute={detailRoute}
				/>
			)}
		</PortfolioEditLayout>
	);
};
